module.exports = __webpack_public_path__ + "static/gallery_05-thumb-10a7f4975650d152d37dba116862f533.jpg";